const REACT_APP_API_URL = `${process.env.REACT_APP_ENV}/api/v1/`;

// Auth
export const API_AUTH = `${REACT_APP_API_URL}auth`;
// User
export const API_USER_GET = `${REACT_APP_API_URL}admin/user`;
// Role
export const API_ROLE_GET = `${REACT_APP_API_URL}admin/role`;
// User Permission
export const API_USER_PERMISSION_GET = `${REACT_APP_API_URL}admin/user-permission`;
// Permission
export const API_PERMISSION_GET = `${REACT_APP_API_URL}admin/permission`;
// Role Has Permission
export const API_ROLE_PERMISSION_GET = `${REACT_APP_API_URL}admin/role-permission`;
// Personil
export const API_PERSONIL_GET = `${REACT_APP_API_URL}admin/personil`;
// Personil List
export const API_PERSONIL_LIST_GET = `${REACT_APP_API_URL}admin/list/personil`;
// Material List
export const API_MATERIAL_GET = `${REACT_APP_API_URL}admin/material`;
// Material Kategori
export const API_MATERIAL_KATEGORI_GET = `${REACT_APP_API_URL}admin/master/material-category`;
// Material List
export const API_SIAPSAT_GET = `${REACT_APP_API_URL}admin/siapsat`;
// Siapsat Kategori
export const API_SIAPSAT_KATEGORI_GET = `${REACT_APP_API_URL}admin/master/binsiapsat-category`;
// Peta Jabatan
export const API_PETA_JABATAN_GET = `${REACT_APP_API_URL}admin/peta-jabatan`;
// Kompers Satjar
export const API_KOMPERS_SATJAR_GET = `${REACT_APP_API_URL}admin/kompers-satjar`;
// Satuan
export const API_SATUAN_GET = `${REACT_APP_API_URL}admin/satuan`;
// Satuan Lambang
export const API_SATUAN_LAMBANG_GET = `${REACT_APP_API_URL}admin/satuan/lambang`;
// Satuan Tradisi
export const API_SATUAN_TRADISI_GET = `${REACT_APP_API_URL}admin/satuan/tradisi`;
// gol jabatan
export const API_GOL_JABATAN_GET = `${REACT_APP_API_URL}admin/gol-jabatan`;
// jabatan
export const API_JABATAN_GET = `${REACT_APP_API_URL}admin/jabatan`;
// Pangkat
export const API_PANGKAT_GET = `${REACT_APP_API_URL}admin/pangkat`;
// Korps
export const API_KORPS_GET = `${REACT_APP_API_URL}admin/korps`;
// Satuan Prestasi
export const API_SATUAN_PRESTASI_GET = `${REACT_APP_API_URL}admin/satuan-prestasi`;
// Satuan Penjabat Dansat
export const API_SATUAN_PEJABAT_DANSAT_GET = `${REACT_APP_API_URL}admin/satuan-jabatan-dansat`;
// Satuan Purnawirawan
export const API_SATUAN_PURNAWIRAWAN_GET = `${REACT_APP_API_URL}admin/satuan-purnawirawan`;
// Satuan Lain Lain
export const API_SATUAN_LAIN_LAIN_GET = `${REACT_APP_API_URL}admin/satuan-lain-lain`;
// Learning
export const API_LEARNING_GET = `${REACT_APP_API_URL}admin/learning`;
// referensi
export const API_REFERENSI_GET = `${REACT_APP_API_URL}admin/referensi`;
// Announcement
export const API_ANNOUNCEMENT_GET = `${REACT_APP_API_URL}admin/pengumuman`;
// Chat
export const API_CHAT_GET = `${REACT_APP_API_URL}admin/chat`;